import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

export const Denied = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div
        className={styles.no_access_message}
        dangerouslySetInnerHTML={{
          __html: t('Chat.AccessIsLimited'),
        }}
      />
    </div>
  )
}
